import { useGetCapabilities1Query } from '@proaxiv/server-api'

/**
 * Returns the caller's global capabilities pre-evaluated by the Drools engine.
 *
 * Wraps {@link useGetCapabilitiesQuery} and normalises the response so that
 * every flag has a safe `false` default while the request is in flight or if
 * the endpoint returns an unexpected shape.
 *
 * The backend enforces all permissions independently on every API request —
 * these flags are informational UI hints only and must not be treated as the
 * authoritative access-control decision.
 */
export function useCapabilities() {
  const { data, isLoading } = useGetCapabilities1Query()
  return {
    isLoading,
    isAdmin: data?.isAdmin ?? false,
    canRead: data?.canRead ?? false,
    canWrite: data?.canWrite ?? false,
    canAccessOwnOrg: data?.canAccessOwnOrg ?? false,
    canAccessService: data?.canAccessService ?? false,
    canCreateEvent: data?.canCreateEvent ?? false,
  }
}
